import { format, isValid, parseISO } from "date-fns"

const DETAILS_DATE_FORMAT = "M/dd/yyyy"

export const formatDetailsDateValue = (value: string | Date) => {
  const parsedValue = typeof value === "string" ? parseISO(value) : value
  const dateValue = isValid(parsedValue) ? parsedValue : new Date(value)

  return isValid(dateValue) ? format(dateValue, DETAILS_DATE_FORMAT) : "--"
}
